<template>
  <div>
    <v-select style="width: 200px;"
              :data="appOptions"
              placeholder="请选择产品"
              :allowClear="false"
              v-model="appValue"></v-select>
    <v-date-picker range
                   style="width:300px;"
                   v-model="rangeDate"
                   clearable
                   @confirm="confirm"
                   @change="rangeChange"></v-date-picker>
    <!-- <v-button type="primary"
              @click="tableFlag=true">查询</v-button> -->
    <v-button type="primary"
              @click="exportExl">导出</v-button>
    <div style="height:20px"></div>
    <el-table :data="tableData"
              v-if="tableFlag"
              style="width: 100%">
      <el-table-column prop="date"
                       label="规格编号">
      </el-table-column>
      <el-table-column prop="name"
                       label="规格名称">
      </el-table-column>
      <el-table-column prop="address"
                       label="已付">
      </el-table-column>
      <el-table-column prop="weifu"
                       label="未付">
      </el-table-column>
      <el-table-column prop="youhui"
                       label="付费转化率">
      </el-table-column>
      <el-table-column prop="money"
                       label="有效订单占比">
      </el-table-column>
    </el-table>
  </div>
</template>

<script>
import axios from 'axios'
export default {
  data () {
    return {
      appOptions: [],
      appValue: '',
      tableFlag: false,
      rangeDate: ['', ''],
      tableData: [{
        date: '541',
        name: '一寸',
        address: '1048',
        weifu: '666',
        youhui: '66%',
        money: '77.7%'
      }, {
        date: '541',
        name: '一寸',
        address: '1048',
        weifu: '666',
        youhui: '66%',
        money: '77.7%'
      }, {
        date: '541',
        name: '一寸',
        address: '1048',
        weifu: '666',
        youhui: '66%',
        money: '77.7%'
      }, {
        date: '541',
        name: '一寸',
        address: '1048',
        weifu: '666',
        youhui: '66%',
        money: '77.7%'
      }]
    }
  },
  methods: {
    exportExl () {
      let startTime, endTime
      if (this.rangeDate[0] !== '') {
        startTime = parseInt(new Date(this.rangeDate[0]).getTime() / 1000)
        endTime = parseInt(new Date(this.rangeDate[1]).getTime() / 1000)
      } else {
        this.$message['error']('请选择时间')
        return
      }
      let url = 'dev/export_order'
      url = url + '/' + startTime + '/' + endTime + '?package_key=' + this.appValue
      axios.get(url).then(res => {
        if (res.data.download_link) {
          window.location.href = res.data.download_link
        }
      })
    },
    getApps () {
      axios.get('/dev/package_info').then(res => {
        let arr = []
        res.data.package_info.forEach(item => {
          let obj = {}
          obj.value = item.value
          obj.label = item.key
          arr.push(obj)
        })
        this.appOptions = arr
      }).catch(err => { console.log(err) })
    },
    confirm () {
      console.log('confirm')
    },
    change (time) {
      console.log('change:', time)
    },
    rangeChange (startTime, endTime) {
      console.log('change:', startTime, endTime)
    }
  },
  mounted () {
    this.getApps()
  }
}
</script>

<style>
</style>



// WEBPACK FOOTER //
// src/pages/order/order-ranking.vue